  var feed = new Instafeed({
    accessToken: instatoken,
    limit: instalimit,
    template: '<div class="box box-7 photo" tabindex="0"><figure><a href="{{link}}" target="_blank" tabindex="-1" class="card__image-wrapper" style="padding-top: 100%;"><div class="card__image" style="background-image:url({{image}})"></div></a><figcaption><p>{{caption}}</p></figcaption></figure></div>',
    transform: function(item) {
      var d = new Date(item.timestamp);
      item.date = [d.getDate(), d.getMonth(), d.getYear()].join('/');
      return item;
    }
  });
  feed.run();